export * from './fr.urls';
